import React, { useEffect, useState } from "react";
import { Card, Col, Row, Stack } from "react-bootstrap";
import { User } from "../../types/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";

interface GuardianState {
  user: User;
}

const GuardianCard = ({ user }: GuardianState) => {
  const [banDateExpired, setBanDateExpired] = useState<boolean>(false);

  useEffect(() => {
    //check ban expiration date
    if (user.banned_expiration_at) {
      const expireDate = new Date(user?.banned_expiration_at);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      setBanDateExpired(expireDate <= today);
    }
  }, [user]);

  function formatPhoneNumber(phoneNumber: string) {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    }
    return phoneNumber;
  }

  function formatAppAccessDate(date: string | null | undefined, appaccess: any) {
    if (!appaccess) {
      return "No app access";
    }
    if (!date) {
      return "Last Access: Never";
    }
    return "Last Access: " + new Date(date).toLocaleDateString("en-US");
  }

  return (
    <Card key={user.id} className={user?.is_banned ? "bg-light card-danger" : "bg-light"}>
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <Stack direction="horizontal" gap={3}>
              <Stack>
                <Card.Subtitle>
                  {user.firstname} {user.preferredname ? "'" + user.preferredname + "'" : ""} {user.lastname}
                </Card.Subtitle>
                <Card.Subtitle className="text-muted mt-1">
                  {user.email !== null ? user.email : ""}
                  {user.email && user.phonenumber ? " | " : ""}
                  {user.phonenumber ? formatPhoneNumber(user.phonenumber) : ""}
                </Card.Subtitle>
              </Stack>
            </Stack>
          </Col>
          <Col className="text-end">
            <Card.Subtitle className="text-muted mt-1">{user.casename} </Card.Subtitle>
            {user?.is_banned === 1 ? (
              <div
                className="position-absolute top-0 end-0"
                data-tooltip-id="tooltip-ban"
                data-tooltip-content={
                  banDateExpired
                    ? `Ban Expired`
                    : `Banned ${user?.banned_expiration_at ? "Until " + user?.banned_expiration_at : "Indefinitely"}`
                }
              >
                <Stack direction="horizontal" className="justify-content-end align-items-center">
                  <FontAwesomeIcon icon={faBan} className="app-danger-text me-2 mt-2" />
                </Stack>
              </div>
            ) : (
              <Stack direction="horizontal" className="justify-content-end">
                <p className="small-text">{formatAppAccessDate(user?.appaccess_last_at, user?.appaccess)}</p>
              </Stack>
            )}
            <Tooltip id="tooltip-ban" place="top" style={{ padding: "5px 10px", zIndex: "100" }} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default GuardianCard;
